module.exports = __webpack_public_path__ + "static/img/function4.60d115ef.png";